// extracted by mini-css-extract-plugin
export default {"timeline":"yItDj","summary":"Qwer7","shortcuts":"FoSU8"};